import {
  getCartLegacy,
  getCart,
  createCart,
  addLine,
  isBuyBack,
  isRefund,
  updateLine,
  deleteLine,
  deleteCart,
  recreatewebcart,
  getsitesettings,
} from '@vue/services/api/cart.api'
import { actionTypes } from '@vue/common/constants/store.types'
import { showInfo, showError } from '@vue/services/toast.service';
import { getProfile } from '@vue/services/api/profile.api';

import {
  SET_IS_SIGNED_IN_TO_LOYALTY
} from '@vue/common/constants/mutation.types';

const initialState = {
  shoppingCart: null,
  showCart: false,
  loading: false,
  hasCart: null,
  cartExpired: false,
  isSignedInToLoyalty: false
}

const state = { ...initialState }

const actions = {
  async init({ dispatch, state }) {
    if (state.hasCart == null) {
      await dispatch('setSignInStatus');
      await dispatch('getCart');
    }
  },
  async getCart({ commit }) {
    try {
      await getCart(); // Returns 404 if cart expired
      commit('setHasCart', true);
      const response =  await getCartLegacy();
      commit('setCart', response.data);
    }
    catch(ex) {
      commit('setHasCart', false);
      if(ex.response.status != 404 && ex.response.status != 401) {
        showError('We couldn\'t get your cart');
      }
    }
  },
  async createCart({ dispatch }, params) {
    const { productId, storeId, initialOrderLine } = params;

    const affiliateCode = sessionStorage.getItem('affiliateCode')
        ? sessionStorage.getItem('affiliateCode')
        : null;

    const response = await createCart( 
      { 
        storeId: storeId,
        productId: productId,
        affiliateCode: affiliateCode,
      }
    );

    await dispatch(actionTypes.AddLine, initialOrderLine);

    return Promise.resolve(response);
  },
  async recreatewebcart({ }, id) {
      await recreatewebcart(id);
  }, 
   getsitesettings({ commit }, id) {        
     getsitesettings(id).then(({ data }) => {
       commit('siteSettings',data) 
     })
   },
  [actionTypes.AddLine]({ commit }, line) {
    return addLine({
      currencyCode: line.currencyCode,
      qty: line.qty,
    }).then(({ data }) => {
      commit('setCart', data)
    })
  },  
  [actionTypes.IsBuyBack]({ commit }, buyback) {
    isBuyBack(buyback).then(({ data }) => {
      commit('setCart', data)
    })
  },
  [actionTypes.IsRefund]({ commit }, refund) {
    isRefund(refund).then(({ data }) => {
      commit('setCart', data)
    })
  },
  [actionTypes.UpdateLine]({ commit }, params) {
    updateLine(params.id, {
      currencyCode: params.code,
      qty: params.quantity,
    }).then(({ data }) => {
      commit('setCart', data)
    })
  },
  [actionTypes.DeleteLine]({ commit }, id) {
    deleteLine(id).then(({ data }) => {
      commit('setCart', data)
    })
  },
  abandonCart({ commit, state, rootState }) {
    if (state.shoppingCart || rootState.checkout.order) {
      commit('clearCart');
      deleteCart().then(() => {
        showInfo({ text: 'We\'ve cleared your cart' });
      }).finally(() => {
        setTimeout(() => {
          window.location = '/';
        }, 1000);
      });
    }
  },
  setCartExpired({ commit }, flag) {
    commit('setCartExpired', flag);
  },
  async setSignInStatus({ commit }) {
    try {
      await getProfile();
      commit(SET_IS_SIGNED_IN_TO_LOYALTY, true);
    }
    catch(ex) {
      commit(SET_IS_SIGNED_IN_TO_LOYALTY, false);
    }
  }
}

const mutations = {
  loadingCart(state, flag) {
    state.loading = flag
  },
  setHasCart(state, cart) {
    state.hasCart = cart
  },
  setCartExpired(state, flag) {
    state.cartExpired = flag
  },
  setCart(state, cart) {
    state.shoppingCart = cart
  },  
  clearCart(state) {
    state.hasCart = false;
    state.shoppingCart = null
  },
  toggleCart(state, flag) {
    state.showCart = flag
    document.dispatchEvent(new Event('cartToggled'));
  },
  [SET_IS_SIGNED_IN_TO_LOYALTY](state, isSignedInToLoyalty) {
    state.isSignedInToLoyalty = isSignedInToLoyalty
  }
}

const getters = {
  hasCart: (state) => !!state.shoppingCart
}; 

const cart = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}

export default cart
